export default __webpack_public_path__ + "53516f03babc234e6eba3de10503d346.png";